import Header from "@/reusable_sections/Header";
import TheHero from "./sections/TheHero";
import LegacyFoundation from "./sections/LegacyFoundation";
import TheCalling from "./sections/TheCalling";
import TheBurden from "./sections/TheBurden";
import ThePillars from "./sections/ThePillars";
import TheProcess from "./sections/TheProcess";
import TheExperience from "./sections/TheExperience";
import TheArchitect from "./sections/TheArchitect";
import ThePrivacyPromise from "./sections/ThePrivacyPromise";
import SecureLegacy from "./sections/SecureLegacy";
import Contact from "./sections/Contact";
import CallToAction from "./sections/CallToAction";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <TheHero />
      <LegacyFoundation />
      <TheCalling />
      <TheBurden />
      <ThePillars />
      <TheProcess />
      <TheExperience />
      <TheArchitect />
      <ThePrivacyPromise />
      <SecureLegacy />
      <Contact />
      <CallToAction />
      <Footer />
    </div>;
}